// services/socket.js
import openSocket from "socket.io-client";
import { isObject } from "lodash";

export function socketConnection(params) {
  let userId = null;

  // Tenta pegar do localStorage
  if (typeof localStorage !== "undefined" && localStorage.getItem("userId")) {
    userId = localStorage.getItem("userId");
  }

  // Usa o userId do params, se existir, senão usa o do localStorage
  const finalUserId = isObject(params) ? params.userId || userId : userId;

  return openSocket(process.env.REACT_APP_BACKEND_URL, {
    transports: ["websocket", "polling"],
    // Obs.: pingTimeout/pingInterval são opções exclusivas do SERVIDOR
    // (configuradas em backend/src/libs/socket.ts). Aqui no cliente eram
    // silenciosamente ignoradas, por isso foram removidas.
    // forceNew: garante uma conexão INDEPENDENTE por chamada.
    // Sem isso, o socket.io-client faz multiplexing e devolve o MESMO socket
    // para a mesma URL/namespace. Como vários componentes (Ticket, MessagesList,
    // TicketsListCustom, NotificationsPopOver) criam socket ao mesmo tempo e cada
    // um chama socket.disconnect() no cleanup do useEffect, o disconnect de um
    // derrubava a conexão de todos. Além disso, o handler "connect" (que emite
    // joinChatBox) não disparava de novo quando o socket já vinha conectado,
    // então o cliente nunca entrava na sala do ticketId e as mensagens novas só
    // apareciam após F5. Com forceNew cada useEffect gerencia o seu próprio socket.
    forceNew: true,
    query: {
      userId: finalUserId,
      ...(isObject(params) ? params : {})
    },
  });
}